import React, { useEffect, useState } from "react";
import { useInterviewContext } from "../InterviewContext";
import { useTranslation } from "react-i18next";
import RecommendedForm from "../List/RecommendedForm";
import ModalDNASentSuccessfully from "../InterviewOptions/ModalDNASentSuccessfully";
import DOCOnlineSpinner from "../../../containers/FullPageSpinner/FullPageSpinner";
import HeaderThreeDotsDropDown from "../HeaderThreeDotsDropDown";
import { toast } from "react-toastify";
import { InterviewService } from "../../../services/InterviewService";
import "../Interview.scss";
import "../../styles/forms.scss";
import InterviewBadge from "../interviewBadge";
import RoleInformationSection from "./RoleInformationSection";
import InterviewTabSection from "../ViewInterview/InterviewTabSection";
import { useGeneralContext } from "../../General/Context";

const InterviewPreviewPage = ({ id, noActions, interview, setInterview }) => {
  const {
    openModalInterviewHistory,
    sendDocOnline,
    shoModalSendDNA,
    setShowModalSendDNA,
    openFinancialCalculation,
    newApplicationAvailable,
    availabilityListStatus,
    fromUrl,
    updateDocumentsGrid,
    setUpdatesDocumentsGrid
  } = useInterviewContext();

  const { t } = useTranslation();
  const { userInformation } = useGeneralContext();
  const SCREENCALL = 2;
  
  function toggleFavorite() {
    if (interview.favorite) {
      InterviewService.deleteFavorite(interview.interviewId).then(() => {
        setInterview({ ...interview, favorite: false });
      });
    } else {
      InterviewService.addFavorite(interview.interviewId).then(() => {
        setInterview({ ...interview, favorite: true });
      });
    }
  }

  const [isOpenRecommendForm, setIsOpenRecommendForm] = useState(false);
  const [recommendedInterview, setRecommendedInterview] = useState({
    usersRecommendedBy: [],
    comment: ""
  });
  const [recommendedManagers, setRecommendedManagers] = useState();
  const [
    currentRecommendedManagerId,
    setCurrentRecommendedManagerId
  ] = useState();

  useEffect(() => {
    if (interview) getRecommendedManagers();
  }, [interview]);

  const getRecommendedManagers = () => {
    let interviewId =
      interview?.interviewId !== 0 ? interview?.interviewId : Number(id);
    if (interviewId !== 0) {
      InterviewService.getRecommendedManagersByInterview(interviewId).then(
        (result) => {
          if (result) {
            let recommendedManagers = result.usersRecommendedBy
              .flatMap((item) => item.userRecommendedToInterview)
              .map((item) => {
                return {
                  id: item.recommendedToId,
                  nickname: item.recommendedTo
                };
              });
            setRecommendedInterview(result);
            setRecommendedManagers(
              Array.from(new Set(recommendedManagers.map(JSON.stringify))).map(
                JSON.parse
              )
            );
          }
        }
      );
    }
  };

  const openRecommendedForm = () => {
    setIsOpenRecommendForm(true);
  };

  const closeRecomendForm = () => {
    setCurrentRecommendedManagerId(0);
    setIsOpenRecommendForm(false);
  };

  const getRecommendedByValue = () => {
    if (recommendedInterview?.usersRecommendedBy.length > 0) {
      return recommendedInterview.usersRecommendedBy
        .map((user) => user.recommendedBy ?? "")
        .join(" | ");
    } else {
      return "";
    }
  };

  const checkIfManagerCheckBoxIsDisabled = (managerId) => {
    return managerId !== userInformation?.id;
  };

  const checkIfCurrentRecommendedManagerIsChecked = (managerId) => {
    return managerId !== currentRecommendedManagerId;
  };

  const onChangeCurrentRecommendedManager = (event) => {
    if (currentRecommendedManagerId !== Number(event.target.value)) {
      setCurrentRecommendedManagerId(Number(event.target.value));
    } else {
      setCurrentRecommendedManagerId(0);
    }
  };

  const saveChangesRecommendedManagers = () => {
    if (currentRecommendedManagerId === 0) {
      closeRecomendForm();
    } else {
      InterviewService.removeRecommendedManager(
        currentRecommendedManagerId,
        interview.interviewId
      ).then(() => {
        getRecommendedManagers();
        closeRecomendForm();
        toast.success(t("Recommended manager changed"));
      });
    }
  };

  if (interview) {
    return (
      <>
        <RoleInformationSection
          interview={interview}
          recommendedManagers={recommendedManagers}
          availabilityListStatus={availabilityListStatus}
          sendDocOnline={sendDocOnline}
          getRecommendedByValue={getRecommendedByValue}
          openRecommendedForm={openRecommendedForm}
          toggleFavorite={toggleFavorite}
        >
          {" "}
          <HeaderThreeDotsDropDown
            isInterviewActive={interview.isActive}
            hasInterviewId={interview.interviewId === 0}
            fromUrl={"view"}
            hideOnscreenCall={interview.typeOfInterview === SCREENCALL}
            openInterviewPage={openFinancialCalculation}
            openModalInterviewHistory={openModalInterviewHistory}
            sendDocOnline={sendDocOnline}
            interview={interview}
            setInterview={setInterview}
            toggleFavorite={toggleFavorite}
            noActions={noActions}
          />
        </RoleInformationSection>
        <InterviewTabSection
          interview={interview}
          id={id}
          newApplicationAvailable={newApplicationAvailable}
          updateDocumentsGrid={updateDocumentsGrid}
          setUpdatesDocumentsGrid={setUpdatesDocumentsGrid}
          fromUrl={fromUrl}
        />
        <RecommendedForm
          isOpen={isOpenRecommendForm}
          closeForm={closeRecomendForm}
          managers={recommendedManagers}
          modalTitle={t("Managers who received the share")}
          submitText={t("Save")}
          commentIsDisabled={true}
          showCheckAllButton={false}
          checkedRecommended={checkIfCurrentRecommendedManagerIsChecked}
          submitButton={saveChangesRecommendedManagers}
          comment={recommendedInterview.comment}
          checkBoxIsDisabled={checkIfManagerCheckBoxIsDisabled}
          onChangeManagers={onChangeCurrentRecommendedManager}
        />

        <InterviewBadge text={interview.personalInformation?.fullName} />

        <ModalDNASentSuccessfully
          showModal={shoModalSendDNA}
          setShowModal={setShowModalSendDNA}
        />
      </>
    );
  } else {
    return <DOCOnlineSpinner text={t("Please wait while the page loads...")} />;
  }
};

export default InterviewPreviewPage;
